export default __webpack_public_path__ + "static/media/sala-pietra-ouside.39521277.jpg";